module.exports = __webpack_public_path__ + "img/jewelry.42937af.webp";